import type { TranslationMessages } from '../types';

export const campaign_report: TranslationMessages = {
  title: 'Campaign Report',
  loading: 'Loading campaign report...',
  load_error: 'Failed to load report',
  back_to_campaigns: 'Back to Campaigns',
  revenue_metrics: 'Revenue Metrics',
  total_revenue: 'Total Revenue',
  category_revenue: 'Category Revenue',
  average_order_value: 'Average Order Value',
  average_daily_revenue: 'Average Daily Revenue',
  average_daily_campaign_revenue: 'Average Daily Campaign Revenue',
  campaign_period_total: 'Campaign period total',
  campaign_category_sales: 'Campaign category sales',
  aov_during_campaign: 'AOV during campaign',
  daily_average: 'Daily average',
  daily_average_all_orders: 'Average for all orders',
  daily_average_campaign_orders: 'Average for campaign orders',
  product_performance: 'Product Performance',
  total_items_sold: 'Total Items Sold',
  campaign_items_sold: 'Campaign Items Sold',
  daily_sell_through: 'Daily Sell-Through',
  all_products: 'All products',
  campaign_category_products: 'Campaign category/products',
  average_units_per_day: 'Average units per day',
  top_20_products: 'Top 20% Products',
  top_products: 'Top Products',
  units: 'units',
  customer_metrics: 'Customer Metrics',
  total_customers: 'Total Customers',
  repeat_purchase_rate: 'Repeat Purchase Rate',
  new_customers: 'New Customers',
  unique_customers: 'Unique customers',
  repeat_customers: 'repeat customers',
  of_total: 'of total',
  target_vs_actual: 'Target vs Actual',
  daily_breakdown: 'Daily Breakdown',
  orders: 'orders',
  of_target: 'of target',
  target: 'Target',
  campaign_duration: 'Campaign Duration',
  days_remaining: 'Days Remaining',
  days: 'days',
  remaining: 'remaining',
  ended: 'Ended',
  target_avg_per_30_days: 'Target Avg per 30 Days',
  target_avg_per_day: 'Target Avg per Day',
  };
